<!-- ============================================================
     LUCKYCREST — SOVEREIGN VERTICAL LEFT SIDEBAR
     Genuine Left-Side Architecture | Luxury Burgundy Theme
     ============================================================ -->

<!-- ── Desktop Vertical Left Sidebar ── -->
<div class="vertical-sidebar-shell hidden lg:flex" >
  <div class="sidebar-track-container">

    <!-- Search Capsule (Top of Sidebar) -->
    <div class="sidebar-search-box">
      <i class="fas fa-search search-icon"></i>
      <input
        type="text"
        class="search-input"
        placeholder="Search games..."
        [(ngModel)]="searchTerm"
      />
    </div>

    <!-- Scrollable Navigation Matrix -->
    <div class="sidebar-scrollable-matrix">

      <!-- Section: Main Games -->
      <div class="sidebar-group">
        <span class="group-header">GAMES & LOBBY</span>
        <nav class="group-nav">
          <!-- All Games -->
          <a
            class="sidebar-nav-link"
            routerLink="/dashboard/home"
            routerLinkActive="is-active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="link-icon-wrap">
              <img loading="lazy" src="icons/game.svg" class="link-icon" alt="" />
            </span>
            <span class="link-title">Games Lobby</span>
            <span class="link-active-laser" aria-hidden="true"></span>
          </a>

          <!-- Hot Games -->
          <a
            class="sidebar-nav-link sidebar-nav-link--hot"
            *ngIf="hotCount > 0"
            (click)="goToHotGames()"
          >
            <span class="link-icon-wrap link-icon-wrap--hot">
              <img loading="lazy" src="icons/hot.svg" class="link-icon" alt="" />
            </span>
            <span class="link-title">Hot Games</span>
            <span class="hot-badge">LIVE</span>
            <span class="link-active-laser" aria-hidden="true"></span>
          </a>

          <!-- Spin Wheel -->
          <a
            class="sidebar-nav-link"
            routerLink="/dashboard/spinner"
            routerLinkActive="is-active"
          >
            <span class="link-icon-wrap">
              <img loading="lazy" src="icons/spin.svg" class="link-icon" alt="" />
            </span>
            <span class="link-title">Spin Wheel</span>
            <span class="link-active-laser" aria-hidden="true"></span>
          </a>

          <!-- Scratch Cards -->
          <a
            class="sidebar-nav-link"
            routerLink="/dashboard/scratch"
            routerLinkActive="is-active"
            (click)="RedirectToScratchCard()"
          >
            <span class="link-icon-wrap">
              <img loading="lazy" src="icons/scratch-card.svg" class="link-icon" alt="" />
            </span>
            <span class="link-title">Scratch Cards</span>
            <span class="link-active-laser" aria-hidden="true"></span>
          </a>
        </nav>
      </div>

      <!-- Section: Cashier & Accounts -->
      <div class="sidebar-group">
        <span class="group-header">FINANCIAL & VAULT</span>
        <nav class="group-nav">
          <!-- Wallet -->
          <a
            class="sidebar-nav-link"
            routerLink="/dashboard/wallet"
            routerLinkActive="is-active"
          >
            <span class="link-icon-wrap">
              <img loading="lazy" src="icons/wallet.svg" class="link-icon" alt="" />
            </span>
            <span class="link-title">Wallet & Cashier</span>
            <span class="link-active-laser" aria-hidden="true"></span>
          </a>

          <!-- Game Account -->
          <a
            class="sidebar-nav-link"
            routerLink="/dashboard/account"
            routerLinkActive="is-active"
          >
            <span class="link-icon-wrap">
              <img loading="lazy" src="icons/game-account.svg" class="link-icon" alt="" />
            </span>
            <span class="link-title">Game Accounts</span>
            <span class="link-active-laser" aria-hidden="true"></span>
          </a>
        </nav>
      </div>

      <!-- Section: VIP Suite & Settings -->
      <div class="sidebar-group">
        <span class="group-header">PLAYER PROTOCOLS</span>
        <nav class="group-nav">
          <!-- Profile Dossier -->
          <a
            class="sidebar-nav-link"
            routerLink="/dashboard/profile"
            routerLinkActive="is-active"
          >
            <span class="link-icon-wrap">
              <i class="far fa-user text-xs text-[#E7CA96]"></i>
            </span>
            <span class="link-title">Profile Dossier</span>
            <span class="link-active-laser" aria-hidden="true"></span>
          </a>

          <!-- Security -->
          <a
            class="sidebar-nav-link"
            routerLink="/dashboard/changePass"
            routerLinkActive="is-active"
          >
            <span class="link-icon-wrap">
              <i class="fas fa-shield-alt text-xs text-[#E7CA96]"></i>
            </span>
            <span class="link-title">Security & Key</span>
            <span class="link-active-laser" aria-hidden="true"></span>
          </a>

          <!-- KYC -->
          <a
            class="sidebar-nav-link"
            routerLink="/dashboard/KYCform"
            routerLinkActive="is-active"
          >
            <span class="link-icon-wrap">
              <i class="fas fa-fingerprint text-xs text-[#E7CA96]"></i>
            </span>
            <span class="link-title">KYC Verification</span>
            <span class="link-active-laser" aria-hidden="true"></span>
          </a>

          <!-- Terms -->
          <a
            class="sidebar-nav-link"
            routerLink="/dashboard/Terms&Conditions"
            routerLinkActive="is-active"
          >
            <span class="link-icon-wrap">
              <i class="fas fa-file-contract text-xs text-[#FAF4EB]"></i>
            </span>
            <span class="link-title">Terms & Rules</span>
            <span class="link-active-laser" aria-hidden="true"></span>
          </a>
        </nav>
      </div>

    </div>

    <!-- Bottom Player Card & Logout -->
    <div class="sidebar-footer-pod">
      <div class="sidebar-player-chip" (click)="redirectTo('/dashboard/profile')">
        <div class="player-avatar-box">
          <img
            loading="lazy"
            [src]="profileImage"
            alt="Avatar"
            class="avatar-img"
            onerror="this.src = '/avatar.png'"
          />
        </div>
        <div class="player-info-meta">
          <span class="player-username">{{ userName || "@player" }}</span>
          <span class="player-tier-badge" *ngIf="playerLevelName">
            <fa-icon [icon]="faCrown" class="text-[#E7CA96] mr-1 text-[9px]"></fa-icon>
            {{ playerLevelName }}
          </span>
        </div>
      </div>

      <button
        type="button"
        (click)="showLogoutModal()"
        class="sidebar-logout-btn"
        title="Logout"
      >
        <i class="fas fa-power-off"></i>
      </button>
    </div>

  </div>
</div>



<!-- ── Mobile Slide-Out Drawer (Activated by Hamburger in Header) ── -->
<div
  class="mobile-sidebar"
  [class.open]="isSidebarOpen"
  (click)="closeSidebarMobile()"
>
  <div class="nexus-drawer-panel" (click)="$event.stopPropagation()">

    <div class="nexus-header-terminal">
      <div class="terminal-brand-lockup">
        <span class="terminal-status-dot"></span>
        <span class="terminal-title">LUCKYCREST SIDEBAR</span>
      </div>
      <button class="nexus-exit-btn" (click)="closeSidebarMobile()" aria-label="Exit">
        <i class="fas fa-times text-xs"></i>
      </button>
    </div>

    <div class="nexus-scroll-chamber">

      <!-- Profile Card -->
      <div class="nexus-player-plate" (click)="redirectTo('/dashboard/profile')">
        <div class="player-plate-hex">
          <img
            loading="lazy"
            [src]="profileImage"
            class="plate-avatar-img"
            onerror="this.src = '/avatar.png'"
            alt="Avatar"
          />
        </div>
        <div class="player-plate-details">
          <h3 class="player-plate-name">{{ userName || '@player' }}</h3>
          <div class="player-plate-rank" *ngIf="playerLevelName">
            <fa-icon [icon]="faCrown" class="text-[#E7CA96] mr-1 text-[9px]"></fa-icon>
            <span>{{ playerLevelName }}</span>
          </div>
          <p class="player-plate-sub">{{ email }}</p>
        </div>
      </div>

      <!-- Gaming Navigation -->
      <div class="nexus-module">
        <span class="nexus-module-tag">GAMES & DESTINATIONS</span>
        <div class="nexus-grid-2x2">
          <a class="nexus-grid-tile" routerLink="/dashboard/home" routerLinkActive="is-engaged" (click)="closeSidebarMobile()">
            <div class="tile-icon-box"><img loading="lazy" src="icons/home.svg" alt="" /></div>
            <span class="tile-label">Lobby</span>
          </a>

          <a class="nexus-grid-tile nexus-grid-tile--hot" *ngIf="hotCount > 0" (click)="goToHotGames(); closeSidebarMobile()">
            <div class="tile-icon-box tile-icon-box--hot"><img loading="lazy" src="icons/hot.svg" alt="" /></div>
            <span class="tile-label">Hot Games</span>
          </a>

          <a class="nexus-grid-tile" routerLink="/dashboard/spinner" routerLinkActive="is-engaged" (click)="closeSidebarMobile()">
            <div class="tile-icon-box"><img loading="lazy" src="icons/spin.svg" alt="" /></div>
            <span class="tile-label">Spin Wheel</span>
          </a>

          <a class="nexus-grid-tile" routerLink="/dashboard/scratch" routerLinkActive="is-engaged" (click)="closeSidebarMobile()">
            <div class="tile-icon-box"><img loading="lazy" src="icons/scratch-card.svg" alt="" /></div>
            <span class="tile-label">Scratch</span>
          </a>
        </div>
      </div>

      <!-- Protocols -->
      <div class="nexus-module">
        <span class="nexus-module-tag">PLAYER PROTOCOLS</span>
        <div class="nexus-matrix-list">
          <a class="matrix-row" routerLink="/dashboard/profile" (click)="closeSidebarMobile()">
            <span class="matrix-row-icon"><i class="fas fa-id-badge text-[#E7CA96]"></i></span>
            <span class="matrix-row-txt">Profile Dossier</span>
          </a>
          <a class="matrix-row" routerLink="/dashboard/wallet" (click)="closeSidebarMobile()">
            <span class="matrix-row-icon"><i class="fas fa-wallet text-[#E7CA96]"></i></span>
            <span class="matrix-row-txt">Wallet & Cashier</span>
          </a>
          <a class="matrix-row" routerLink="/dashboard/changePass" (click)="closeSidebarMobile()">
            <span class="matrix-row-icon"><i class="fas fa-shield-alt text-[#E7CA96]"></i></span>
            <span class="matrix-row-txt">Security Matrix</span>
          </a>
          <a class="matrix-row" routerLink="/dashboard/KYCform" (click)="closeSidebarMobile()">
            <span class="matrix-row-icon"><i class="fas fa-fingerprint text-[#E7CA96]"></i></span>
            <span class="matrix-row-txt">KYC Trust Level</span>
          </a>
          <a class="matrix-row" routerLink="/dashboard/Terms&Conditions" (click)="closeSidebarMobile()">
            <span class="matrix-row-icon"><i class="fas fa-file-contract text-[#FAF4EB]"></i></span>
            <span class="matrix-row-txt">Terms & Rules</span>
          </a>
        </div>
      </div>

      <!-- Logout -->
      <div class="nexus-terminate-wrap">
        <button type="button" (click)="showLogoutModal()" class="nexus-terminate-btn">
          <i class="fas fa-power-off text-sm"></i>
          <span>TERMINATE SESSION</span>
        </button>
      </div>

    </div>

  </div>
</div>

<!-- Logout Modal Preserved -->
<app-logoutmodel
  [isOpen]="isLogoutModalOpen"
  [profileImage]="profileImage"
  (onCancel)="closeLogoutModal()"
  (onConfirm)="logout()"
></app-logoutmodel>
